import { render, staticRenderFns } from "./PatientListSort.vue?vue&type=template&id=0bec6da0&"
import script from "./PatientListSort.vue?vue&type=script&lang=js&"
export * from "./PatientListSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports